import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { AuthProvider } from "./Hooks/useAuth";
import { getFromLocalStorage } from "./Hooks/useLocalStorage";

const root = ReactDOM.createRoot(document.getElementById("root"));

const authData = getFromLocalStorage("authData");

root.render(
  <React.StrictMode>
    <AuthProvider storedAuthData={authData}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
